module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAApCAMAAABEBVrmAAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMA5+AZj2mWCXHQp1kV862ain12Uk0eDMGwkoVAPzMxBz7zq/kAAAB2SURBVDjL7dW3DoAwEANQUxN67+3+/yvRISRGLmxIeZMXj5bR5hpyB0BECUcVOxIRF2oupCSD0skVWOMLTBUs60c2BSMDuR3YHgjohBc3Gy0uI1q40EckkcHTK3DxBLoelvUfbaxh5DlFV+DbKY73KYZF+KqoTn0GG4rvw7iUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/menu.png
// module id = fLB4
// module chunks = 0